export const StepsStatusesMap = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  SIGNED: 'signed'
};

export const StepsNamesMap = {
  MULTI_MATCH: 'Multimatch',
  ASK_CUSTOMER: 'Ask customer',
  COMPOUNDED: 'Compounded',
  IGNORED: 'Ignored'
};

export const StepsList = [
  {
    step: StepsNamesMap.MULTI_MATCH,
    status: null,
    defaultStatus: StepsStatusesMap.PENDING
  },
  {
    step: StepsNamesMap.ASK_CUSTOMER,
    status: null,
    defaultStatus: StepsStatusesMap.PENDING,
    params: {
      statusesNames: ['ask_customer']
    },
    tableColumns: [
      {
        text: 'Category',
        value: 'orig_cat1',
        align: 'center'
      },
      {
        text: 'Id',
        value: 'orig_code',
        align: 'center'
      },
      {
        text: 'Name',
        value: 'orig_name',
        align: 'center'
      },
      {
        text: 'Rhapsody name',
        value: 'rhapsody_name',
        align: 'center'
      },
      {
        text: 'Entry variation name',
        value: 'entry_variation_name',
        align: 'center'
      },
      {
        text: 'Price',
        value: 'priceInfo.price',
        align: 'center'
      },
      {
        text: 'Last sold',
        value: 'priceInfo.lastsold',
        align: 'center'
      },
      {
        text: 'Notes',
        value: 'migrationPoll.notes',
        align: 'center',
        justify: 'flex-end'
      }
    ]
  },
  {
    step: StepsNamesMap.COMPOUNDED,
    status: null,
    defaultStatus: StepsStatusesMap.PENDING,
    params: {
      statusesNames: ['compounded']
    },
    tableColumns: [
      {
        text: 'Category',
        value: 'orig_cat1',
        align: 'center'
      },
      {
        text: 'Id',
        value: 'orig_code',
        align: 'center'
      },
      {
        text: 'Name',
        value: 'orig_name',
        align: 'center'
      },
      {
        text: 'Price',
        value: 'priceInfo.price',
        align: 'center'
      },
      {
        text: 'Last sold',
        value: 'priceInfo.lastsold',
        align: 'center'
      },
      {
        text: 'Notes',
        value: 'migrationPoll.notes',
        align: 'center',
        justify: 'flex-end'
      }
    ]
  },
  {
    step: StepsNamesMap.IGNORED,
    status: null,
    defaultStatus: StepsStatusesMap.PENDING,
    params: {
      categories: ['ignore'],
      sortBy: ['comment']
    }
  }
];
